import {
  APP_ADMIN_ONLY,
  DEFAULT_ACCESS,
  MEMBER_AND_HIGHER,
  SUPERVISOR_AND_HIGHER,
} from "@/router/roles.js";
import Login from "@/features/auth/Login.jsx";
import ResetPassword from "@/features/auth/ResetPassword.jsx";
import ResetPasswordConfirm from "@/features/auth/ResetPasswordConfirm.jsx";
import EmailVerificationResend from "@/features/auth/EmailVerificationResend.jsx";
import EmailVerification from "@/features/auth/EmailVerification.jsx";
import Home from "@/features/home/index.jsx";
import Register from "@/features/auth/Register.jsx";
import SurveySectionForm from "@/features/survey/components/active-survey-form/SurveySectionForm.jsx";
import SurveyList from "@/features/survey/pages/SurveyList.tsx";
import SingleSurvey from "@/features/survey/pages/SingleSurvey.jsx";
import SurveyInvites from "@/features/survey/pages/SurveyInvites.jsx";
import PrivacyPolicy from "@/features/PrivacyPolicy.jsx";
import Community from "@/features/community/Community.jsx";
import DiscussionForm from "@/features/community/DiscussionForm.jsx";
import SingleDiscussion from "@/features/community/SingleDiscussion.jsx";
import CommunityTopicSearch from "@/features/community/CommunityTopicSearch.jsx";
import CommunitySearch from "@/features/community/CommunitySearch.jsx";
import OldSurveyView from "@/features/survey/components/survey-views/SurveyView.jsx";
import DataBlocksDocumentation from "@/features/datablocks/pages/DataBlocksDocumentation.tsx";
import DataBlockContainer from "@/features/datablocks/pages/DataBlockContainer.tsx";
import UpdateDataBlock from "@/features/datablocks/pages/UpdateDataBlock.tsx";
import DataBlocksList from "@/features/datablocks/pages/DataBlocksList.tsx";
import SubmissionSuccessPage from "@/features/survey/components/active-survey-form/SubmissionSuccessPage.jsx";
import SurveyViewCreate from "@/pages/survey-views/SurveyViewCreate.tsx";
import SurveyViewUpdate from "@/pages/survey-views/SurveyViewUpdate.tsx";
import SurveyView from "@/pages/survey-views/SurveyView.tsx";
import PublicFile from "@/pages/survey-views/PublicFile.tsx";
import Organization from "@/pages/organizations/Organization.tsx";
import Directory from "@/pages/directory/Directory.tsx";
import SurveyViewList from "@/pages/survey-views/SurveyViewList.js";
import DataFiles from "@/pages/files/DataFiles.js";
import User from "@/pages/users/User.js";
import UserSettings from "@/pages/settings/UserSettings.js";
import DataBlockRequests from "@/features/evidence-requests/list";

export const PublicRoutes = [
  {
    path: "/login",
    view: Login,
  },
  {
    path: "/register",
    view: Register,
  },
  {
    path: "/reset-password/confirm",
    view: ResetPasswordConfirm,
  },
  {
    path: "/reset-password",
    view: ResetPassword,
  },
  {
    path: "/email-verification",
    view: EmailVerification,
  },
  {
    path: "/email-verification/resend",
    view: EmailVerificationResend,
  },
  {
    path: "/public/reports/files/:uuid",
    view: PublicFile,
  },
  {
    path: "/public/reports/views/:surveyViewUuid",
    view: SurveyView,
  },
];

export const PrivateRoutes = [
  {
    path: "/",
    view: Home,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/privacy-policy",
    view: PrivacyPolicy,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/users/:userId",
    view: User,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/settings",
    view: UserSettings,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/directory",
    view: Directory,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/signatories/:organizationId",
    view: Organization,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/evidence",
    view: DataBlocksList,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/evidence/:dataBlockId",
    view: DataBlockContainer,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/evidence/:dataBlockId/edit",
    view: UpdateDataBlock,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/evidence/documentation",
    view: DataBlocksDocumentation,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/evidence/invites",
    view: DataBlockRequests,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/files",
    view: DataFiles,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/reports",
    view: SurveyList,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/reports/:surveyId",
    view: SingleSurvey,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/reports/:surveyId/sample",
    view: SingleSurvey,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/reports/:surveyId/section/:sectionId",
    view: SurveySectionForm,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/reports/:surveyId/section/:sectionId/sample",
    view: SurveySectionForm,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/reports/:surveyId/submission-success",
    view: SubmissionSuccessPage,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/reports/:surveyId/invites",
    view: SurveyInvites,
    ...APP_ADMIN_ONLY,
  },
  {
    path: "/reports/:surveyId/report",
    view: OldSurveyView,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/reports/views",
    view: SurveyViewList,
    ...MEMBER_AND_HIGHER,
  },
  {
    path: "/reports/views/:surveyViewUuid",
    view: SurveyView,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/reports/views/form",
    view: SurveyViewCreate,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/reports/views/:surveyViewUuid/form",
    view: SurveyViewUpdate,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/community",
    view: Community,
    ...MEMBER_AND_HIGHER,
  },
  {
    path: "/community/search",
    view: CommunitySearch,
    ...MEMBER_AND_HIGHER,
  },
  {
    path: "/community/topics/:topic",
    view: CommunityTopicSearch,
    ...MEMBER_AND_HIGHER,
  },
  {
    path: "/discussions/:discussionId",
    view: SingleDiscussion,
    ...MEMBER_AND_HIGHER,
  },
  {
    path: "/discussions/form",
    view: DiscussionForm,
    ...MEMBER_AND_HIGHER,
  },
  {
    path: "/discussions/form/:discussionId",
    view: DiscussionForm,
    ...MEMBER_AND_HIGHER,
  },
  {
    path: "/reports/files/:uuid",
    view: PublicFile,
    ...DEFAULT_ACCESS,
  },
];
